import {
  MassiveStatusTarget,
  downloadMassiveStatusTemplate,
  uploadMassiveStatusFile,
} from "../services/massiveStatusUpload";

export const useMassiveStatusUpload = (target: MassiveStatusTarget) => {
  const downloadTemplate = () => downloadMassiveStatusTemplate(target);

  const upload = (file: File) => uploadMassiveStatusFile(target, file);

  return { downloadTemplate, upload };
};
